import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptSpeakerAssignmentFailedAction = {
	type: 'TRANSCRIPT_SPEAKER_ASSIGNMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptSpeakerAssignmentFailedAction => ({
	type: 'TRANSCRIPT_SPEAKER_ASSIGNMENT_FAILED',
	payload,
});
